import { render } from "./active-logs-view-page.vue?vue&type=template&id=34f5dae6"
import script from "./active-logs-view-page.vue?vue&type=script&lang=ts"
export * from "./active-logs-view-page.vue?vue&type=script&lang=ts"

import "./active-logs-view-page.vue?vue&type=style&index=0&id=34f5dae6&lang=less"
script.render = render

export default script